export default __webpack_public_path__ + "static/media/ys3.3108bd66.jpg";